// Date range calculation utilities - returns ISO 8601 format
export const getDateRange = rangeType => {
    const today = new Date();

    // This Week: Last 7 days
    const thisWeekStart = new Date(today);
    thisWeekStart.setDate(today.getDate() - 7);
    const thisWeekEnd = today;

    // Last Week: Days 8-14 (14-7 days ago)
    const lastWeekEnd = new Date(today);
    lastWeekEnd.setDate(today.getDate() - 7);
    const lastWeekStart = new Date(today);
    lastWeekStart.setDate(today.getDate() - 14);

    // This Month: Last 30 days
    const thisMonthEnd = today;
    const thisMonthStart = new Date(today);
    thisMonthStart.setDate(today.getDate() - 30);

    // Last Month: Days 31-60 (60-30 days ago)
    const lastMonthEnd = new Date(today);
    lastMonthEnd.setDate(today.getDate() - 30);
    const lastMonthStart = new Date(today);
    lastMonthStart.setDate(today.getDate() - 60);

    // Last 3 Months: Last 90 days
    const last3MonthsStart = new Date(today);
    last3MonthsStart.setDate(today.getDate() - 90);
    const last3MonthsEnd = today;

    const formatDate = date => date.toISOString();

    const ranges = {
        'This Week': [formatDate(thisWeekStart), formatDate(thisWeekEnd)],
        'Last Week': [formatDate(lastWeekStart), formatDate(lastWeekEnd)],
        'This Month': [formatDate(thisMonthStart), formatDate(thisMonthEnd)],
        'Last Month': [formatDate(lastMonthStart), formatDate(lastMonthEnd)],
        'Last 3 Months': [formatDate(last3MonthsStart), formatDate(last3MonthsEnd)],
    };

    return ranges[rangeType] || [formatDate(thisMonthStart), formatDate(thisMonthEnd)];
};

export const DATE_RANGE_OPTIONS = ['This Week', 'Last Week', 'This Month', 'Last Month', 'Last 3 Months', 'Custom Range'];

// Helper function to detect if current dates match any predefined range
export const getCurrentRangeType = (dateFrom, dateTo) => {
    if (!dateFrom || !dateTo) return null;

    // Extract date portion (YYYY-MM-DD) to avoid time component mismatches
    const extractDatePart = dateString => {
        if (!dateString || typeof dateString !== 'string') return null;
        return dateString.split('T')[0];
    };
    const inputStart = extractDatePart(dateFrom);
    const inputEnd = extractDatePart(dateTo);

    if (!inputStart || !inputEnd) return null;

    for (const rangeType of ['This Week', 'Last Week', 'This Month', 'Last Month', 'Last 3 Months']) {
        const [rangeStart, rangeEnd] = getDateRange(rangeType);
        const rangeStartDate = extractDatePart(rangeStart);
        const rangeEndDate = extractDatePart(rangeEnd);
        
        if (inputStart === rangeStartDate && inputEnd === rangeEndDate) {
            return rangeType;
        }
    }
    return null; // No match found
};
